import React, { useEffect } from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';

const MainLayoute = ({ children }) => {

    useEffect(() => {
        const event = new Event("rendered");
        document.dispatchEvent(event);
    }, []);

    return (
        <>
            <div className="layout-wrapper">
                <Header />
                {children}
                <Footer />
            </div>
        </>
    )
}

export default MainLayoute
